<div
  class="d-flex flex-column flex-shrink-0 p-3"
  [ngClass]="{ collapsed: isCollapsed }"
  id="sidebarMenu"
>
  <div class="sidebar-header" [ngClass]="{ collapsed: isCollapsed }">
    <a routerLink="/dashboard/home">
      <img
        *ngIf="!isCollapsed"
        src="assets/icons/mosadad_logo.svg"
        alt="Mosadad Logo"
        class="sidebar-logo"
      />
      <img
        *ngIf="isCollapsed"
        src="assets/icons/Logo_notext.svg"
        alt="Mosadad Logo"
        class="sidebar-logo-small"
      />
    </a>

    <button class="toggle-button btn btn-link p-0" (click)="toggleSidebar()">
      <img src="assets/grip-lines.png" class="ms-auto" />
    </button>
    <!-- commented out code removed -->
  </div>

  <div class="section-divider"></div>

  <ul class="nav nav-pills flex-column mb-auto">
    <!-- Home menu with Dashboard & Regulator Dashboard sub-items -->
    <li class="nav-item">
      <a
        href="javascript:void(0)"
        class="nav-link"
        [ngClass]="{ active: isHomeActive() }"
        (click)="toggleSubmenu('dashboard/home')"
      >
        <div class="w-100">
          <div>
            <img
              src="assets/icons/side-menu/home.svg"
              class="bi me-2"
              width="15"
              height="15"
              alt=""
            />
            <span *ngIf="!isCollapsed">{{ "sideMenu.home" | translate }}</span>
          </div>
          <div [ngClass]="{ 'd-none': isCollapsed }">
            <img
              src="assets/icons/side-menu/submenu-arrow.svg"
              class="submenu-arrow"
              width="15"
              height="15"
              alt=""
              [ngClass]="{
                'rotate-arrow': isSubmenuActive('dashboard/home'),
              }"
            />
          </div>
        </div>
      </a>

      <ul
        [ngClass]="{ show: isSubmenuActive('dashboard/home') }"
        class="collapse"
      >
        <li>
          <a
            [ngClass]="{ active: isDashboardHomeRoute() }"
            routerLink="home"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <img
              src="assets/icons/side-menu/home.svg"
              class="bi me-2"
              width="15"
              height="15"
              alt=""
            />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.dashboard" | translate
            }}</span>
          </a>
        </li>
        <li>
          <a
            [ngClass]="{ active: isRegulatorHomeRoute() }"
            routerLink="regulator-home"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <img
              src="assets/icons/side-menu/home.svg"
              class="bi me-2"
              width="15"
              height="15"
              alt=""
            />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.regulatorDashboard" | translate
            }}</span>
          </a>
        </li>
      </ul>
    </li>

    <div class="section-divider" *ngIf="!isRegulator && canViewEntities"></div>

    <li class="nav-item">
      <a
        *ngIf="!isRegulator"
        href="javascript:void(0)"
        class="nav-link"
        [ngClass]="{ active: isParentActive('user-management') }"
        (click)="toggleSubmenu('dashboard/user-management')"
      >
        <div class="w-100">
          <div>
            <img
              src="assets/icons/side-menu/user-management.svg"
              class="bi me-2 menu-icon"
              width="15"
              height="15"
              alt=""
            />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.userManagement" | translate
            }}</span>
          </div>

          <div>
            <img
              src="assets/icons/side-menu/submenu-arrow.svg"
              class="submenu-arrow"
              width="15"
              height="15"
              alt=""
              [ngClass]="{
                'rotate-arrow': isSubmenuActive('dashboard/user-management'),
              }"
            />
          </div>
        </div>
      </a>

      <ul
        [ngClass]="{ show: isSubmenuActive('dashboard/user-management') }"
        class="collapse"
      >
        <li>
          <a
            *ngIf="canViewUsers"
            [ngClass]="{ active: isUsersRoute() }"
            routerLink="user-management/users"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <img
              src="assets/icons/side-menu/users.svg"
              class="bi me-2"
              width="15"
              height="15"
              alt=""
            />
            <span *ngIf="!isCollapsed">{{ "sideMenu.users" | translate }}</span>
          </a>
        </li>
        <li>
          <a
            *ngIf="canViewRoles"
            [ngClass]="{ active: isRolesRoute() }"
            routerLink="user-management/roles"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <img
              src="assets/icons/side-menu/roles.svg"
              class="bi me-2"
              width="15"
              height="15"
              alt=""
            />
            <span *ngIf="!isCollapsed">{{ "sideMenu.roles" | translate }}</span>
          </a>
        </li>
      </ul>
    </li>

    <div
      class="section-divider"
      *ngIf="isRegulator || (!isRegulator && canViewEntities)"
    ></div>

    <li class="nav-item">
      <a
        *ngIf="canViewEntities && !isRegulator"
        [ngClass]="{ active: isEntityRoute() }"
        routerLink="/dashboard/entity-management/entities"
        class="nav-link"
      >
        <img
          src="assets/icons/side-menu/entity-management.svg"
          class="bi me-2 menu-icon"
          width="15"
          height="15"
          alt=""
        />
        <span *ngIf="!isCollapsed">{{
          "sideMenu.entityManagement" | translate
        }}</span>
      </a>
    </li>

    <!-- Single separator after Entity section if any of the subsequent groups (Logs, Notifications, SLA) will be shown -->
    <div
      class="section-divider"
      *ngIf="
        !isRegulator &&
        (canViewSystemLogs || canViewNotifications || !canViewSlaConfig)
      "
    ></div>

    <li>
      <a
        *ngIf="isRegulator || canViewReports"
        href="javascript:void(0)"
        class="nav-link"
        [ngClass]="{ active: isParentActive('reports') }"
        (click)="toggleSubmenu('dashboard/reports')"
      >
        <div class="w-100">
          <div>
            <img
              src="assets/icons/side-menu/reports.svg"
              class="bi me-2"
              width="15"
              height="15"
              alt=""
            />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.reports" | translate
            }}</span>
          </div>
          <div [ngClass]="{ 'd-none': isCollapsed }">
            <img
              src="assets/icons/side-menu/submenu-arrow.svg"
              class="submenu-arrow"
              width="15"
              height="15"
              alt=""
              [ngClass]="{
                'rotate-arrow': isSubmenuActive('dashboard/reports'),
              }"
            />
          </div>
        </div>
      </a>
      <ul
        *ngIf="isRegulator || canViewReports"
        [ngClass]="{ show: isSubmenuActive('dashboard/reports') }"
        class="collapse"
      >
        <li>
          <a
            [ngClass]="{ active: isReportsChild('financial') }"
            routerLink="/dashboard/reports/financial"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.financialReports" | translate
            }}</span>
          </a>
        </li>
        <li>
          <a
            [ngClass]="{ active: isReportsChild('special') }"
            routerLink="/dashboard/reports/special"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.specialReports" | translate
            }}</span>
          </a>
        </li>
        <li>
          <a
            [ngClass]="{ active: isReportsChild('positioning') }"
            routerLink="/dashboard/reports/positioning"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.financialPositioning" | translate
            }}</span>
          </a>
        </li>
        <li>
          <a
            [ngClass]="{ active: isReportsChild('tasks-overdue') }"
            routerLink="/dashboard/reports/tasks-overdue"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.tasksOverdueReport" | translate
            }}</span>
          </a>
        </li>
        <li>
          <a
            [ngClass]="{ active: isReportsChild('claims-ageing') }"
            routerLink="/dashboard/reports/claims-ageing"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.claimsAgeingReport" | translate
            }}</span>
          </a>
        </li>
        <li>
          <a
            [ngClass]="{ active: isReportsChild('insurers-by-outstanding') }"
            routerLink="/dashboard/reports/insurers-by-outstanding"
            class="nav-link submenu-item"
          >
            <img src="assets/rectangle.png" class="submenu-indicator" />
            <span *ngIf="!isCollapsed">{{
              "sideMenu.insurersByOutstanding" | translate
            }}</span>
          </a>
        </li>
      </ul>
    </li>

    <li *ngIf="!isRegulator && canViewSystemLogs">
      <a
        [ngClass]="{ active: isLogsRoute() }"
        routerLink="/dashboard/logs-management"
        class="nav-link link-dark"
      >
        <img
          src="assets/icons/side-menu/logs-management.svg"
          class="bi me-2"
          width="15"
          height="15"
          alt=""
        />
        <span *ngIf="!isCollapsed">{{
          "sideMenu.logsManagement" | translate
        }}</span>
      </a>
    </li>

    <!-- Removed extra separator before notifications to prevent duplicate dividers -->

    <li class="nav-item">
      <a
        *ngIf="canViewNotifications && !isRegulator"
        [ngClass]="{ active: isNotificationRoute() }"
        routerLink="/dashboard/notifications"
        class="nav-link"
      >
        <img
          src="assets/icons/side-menu/custom-notifications.svg"
          class="bi me-2"
          width="15"
          height="15"
          alt=""
        />
        <span *ngIf="!isCollapsed">{{
          "sideMenu.customNotifications" | translate
        }}</span>
      </a>
    </li>

    <div class="section-divider"></div>

    <li class="nav-item">
      <a
        *ngIf="!isRegulator && !canViewSlaConfig"
        [ngClass]="{ active: isSlaRoute() }"
        routerLink="/dashboard/sla-configuration"
        class="nav-link"
      >
        <img
          src="assets/icons/side-menu/sla-configuration.svg"
          class="bi me-2"
          width="15"
          height="15"
          alt=""
        />
        <span *ngIf="!isCollapsed">{{
          "sideMenu.SLAConfiguration" | translate
        }}</span>
      </a>
    </li>
  </ul>

  <div class="sidebar-bottom-section" [ngClass]="{ collapsed: isCollapsed }">
    <ul class="nav flex-column">
      <li class="nav-item" (click)="openPopup('notifications')">
        <a role="button" class="nav-link" style="cursor: pointer;">
          <img
            src="assets/icons/side-menu/notifications-bell.svg"
            class="bi me-2"
            width="15"
            height="15"
            alt=""
          />
          <span *ngIf="!isCollapsed">{{
            "sideMenu.notifications" | translate
          }}</span>
        </a>
      </li>

      <li class="nav-item" (click)="openPopup('languages')">
        <a role="button" class="nav-link" style="cursor: pointer;">
          <img
            src="assets/icons/side-menu/languages.svg"
            class="bi me-2"
            width="15"
            height="15"
            alt=""
          />
          <span *ngIf="!isCollapsed">{{
            "sideMenu.languages" | translate
          }}</span>
        </a>
      </li>
      <div *ngIf="showLanguagesMenu" class="languages-menu">
        <ul>
          <li (click)="switchLanguage('en')">{{ "common.english" | translate }}</li>
          <li (click)="switchLanguage('ar')">{{ "common.arabic" | translate }}</li>
        </ul>
      </div>

      <li class="nav-item" (click)="logoutPopup()">
        <a role="button" class="nav-link" style="cursor: pointer;">
          <img
            src="assets/icons/side-menu/logout.svg"
            class="bi me-2"
            width="15"
            height="15"
            alt=""
          />
          <span style="color: #ff0000" *ngIf="!isCollapsed">{{
            "sideMenu.logout" | translate
          }}</span>
        </a>
      </li>

      <div class="section-divider"></div>

      <li class="nav-item user-details" (click)="openPopup('user')">
        <a role="button" class="nav-link" style="cursor: pointer;">
          <img
            src="assets/icons/side-menu/profile.svg"
            class="bi me-2"
            width="15"
            height="15"
            alt=""
          />
          <span *ngIf="!isCollapsed">{{
            "sideMenu.myProfile" | translate
          }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>
<app-dynamic-popup
  [title]="'popups.logoutConfirmation.title' | translate"
  [message]="'popups.logoutConfirmation.message' | translate"
  [actionButtonLabel]="'sideMenu.logout' | translate"
  [isVisible]="isPopupVisible"
  (cancel)="closeLogoutPopup()"
  (confirm)="logout()"
>
</app-dynamic-popup>
